/*
 * COPYRIGHT 2023-2024 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */

import Keycloak from 'keycloak-js';
import KC_CONFIG from './keycloakConfig.js';

const keycloakInstance = new Keycloak(KC_CONFIG);

class UserService {
    static initKeycloak(onAuthenticatedCallback) {
        keycloakInstance.init({
            onLoad: 'login-required'
        }).then((authenticated) => {
            if (!authenticated) {
                console.log("user is not authenticated..!");
            }
            onAuthenticatedCallback();

            setInterval(() => {
                keycloakInstance.updateToken(5);
            }, 15 * 60);

        }).catch(console.error);
    }

    static doLogin() {
        return keycloakInstance.login();
    }

    static doLogout() {
        keycloakInstance.logout();
    }

    static isLoggedIn() {
        return !!keycloakInstance.token;
    }

    static getToken() {
        return keycloakInstance.token;
    }

    static getTokenParsed() {
        return keycloakInstance.tokenParsed;
    }

    static updateToken(successCallback) {
        keycloakInstance.updateToken(5)
            .then(successCallback)
            .catch(UserService.doLogin);
    }

    static getUsername() {
        return keycloakInstance.tokenParsed?.preferred_username;
    }

    static getEmail() {
        return keycloakInstance.tokenParsed?.email;
    }

    static hasRole(roles) {
        return roles.some((role) => keycloakInstance.hasRealmRole(role));
    }
}

export default UserService;
